import React from 'react';

import { TableCell, TableSortLabel } from '@mui/material';

import type { SortDirection } from './useTableSort';

interface Props<F extends string> {
  align?: 'left' | 'center' | 'right';
  children: React.ReactNode;
  field: F;
  onSortChange: (field: F) => void;
  sortDirection: SortDirection;
  sortField: F;
}

export default function SortableTableHeaderCell<F extends string>({
  align,
  children,
  field,
  onSortChange,
  sortDirection,
  sortField,
}: Props<F>) {
  const isActive = sortField === field;

  return (
    <TableCell align={align} sortDirection={isActive ? sortDirection : false}>
      <TableSortLabel
        active={isActive}
        direction={isActive ? sortDirection : 'asc'}
        onClick={() => onSortChange(field)}
      >
        {children}
      </TableSortLabel>
    </TableCell>
  );
}
